import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCMKWS8Nl7LyPGUrkArW8F7YAxOMHnm9lE",
  authDomain: "matri-sakhi.firebaseapp.com",
  databaseURL: "https://matri-sakhi-default-rtdb.firebaseio.com",
  projectId: "matri-sakhi",
  storageBucket: "matri-sakhi.appspot.com",
  messagingSenderId: "133255379137",
  appId: "1:133255379137:web:4bb932393a641fa349bc40",
  measurementId: "G-V9SG8S23ED",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Get a reference to the authentication service
const auth = getAuth(app);

export { auth };
